/**
 * 根据链类型生成区块浏览器链接（与 web-merchant 一致）
 */
export function txExplorerUrl(chain, txHash) {
  if (!txHash || txHash === '—') return ''
  const h = String(txHash).trim()
  if (!h) return ''
  const c = String(chain || '').toUpperCase()

  if (c === 'BTC') {
    return `https://mempool.space/tx/${encodeURIComponent(h)}`
  }
  if (c === 'ERC20' || c === 'ETH') {
    return `https://etherscan.io/tx/${encodeURIComponent(h)}`
  }
  if (c === 'BSC') {
    return `https://bscscan.com/tx/${encodeURIComponent(h)}`
  }
  if (c === 'TRC20') {
    return `https://tronscan.org/#/transaction/${encodeURIComponent(h)}`
  }
  if (c === 'NATIVE' && h.startsWith('0x')) {
    return `https://etherscan.io/tx/${encodeURIComponent(h)}`
  }
  if (h.startsWith('0x') && h.length === 66) {
    return `https://etherscan.io/tx/${encodeURIComponent(h)}`
  }
  return ''
}

export function addressExplorerUrl(chain, address) {
  if (!address) return ''
  const a = String(address).trim()
  if (!a) return ''
  const c = String(chain || '').toUpperCase()

  if (c === 'BTC') {
    return `https://mempool.space/address/${encodeURIComponent(a)}`
  }
  if (c === 'ERC20' || c === 'ETH') {
    return `https://etherscan.io/address/${encodeURIComponent(a)}`
  }
  if (c === 'BSC') {
    return `https://bscscan.com/address/${encodeURIComponent(a)}`
  }
  if (c === 'TRC20') {
    return `https://tronscan.org/#/address/${encodeURIComponent(a)}`
  }
  if (a.startsWith('T') && a.length >= 30 && !a.startsWith('0x')) {
    return `https://tronscan.org/#/address/${encodeURIComponent(a)}`
  }
  if (a.startsWith('0x') && a.length === 42) {
    return `https://etherscan.io/address/${encodeURIComponent(a)}`
  }
  if (/^(bc1|1|3)[a-zA-Z0-9]{25,62}$/.test(a)) {
    return `https://mempool.space/address/${encodeURIComponent(a)}`
  }
  return ''
}
